module.exports = __webpack_public_path__ + "img/invite.f46e0a63.svg";